import { render, staticRenderFns } from "./receiveList.vue?vue&type=template&id=032c8f3d&"
import script from "./receiveList.vue?vue&type=script&lang=js&"
export * from "./receiveList.vue?vue&type=script&lang=js&"
import style0 from "./receiveList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports